/* OnlineStore24 — theme.js base */
(function(){
  'use strict';
  // Placeholder para mejoras progresivas globales.
  // Carrito ajax, drawer, etc. se añaden en fase 2.
  document.addEventListener('DOMContentLoaded', function(){
    // marcar enlace activo de nav según URL
    var path = window.location.pathname;
    document.querySelectorAll('.site-nav a').forEach(function(a){
      if(a.getAttribute('href') === path){ a.classList.add('active'); }
    });
  });
})();

/* ===== DROPDOWN SUBCATEGORÍAS (desktop hover + móvil tap) ===== */
(function(){
  var MOBILE = 900;
  var items = document.querySelectorAll('.site-nav .nav-item.has-sub');

  items.forEach(function(item){
    var timer;
    var topLink = item.querySelector('.nav-top');

    // --- DESKTOP: hover ---
    item.addEventListener('mouseenter', function(){
      if(window.innerWidth <= MOBILE) return;
      clearTimeout(timer);
      items.forEach(function(i){ if(i!==item) i.classList.remove('open'); });
      item.classList.add('open');
    });
    item.addEventListener('mouseleave', function(){
      if(window.innerWidth <= MOBILE) return;
      timer = setTimeout(function(){ item.classList.remove('open'); }, 180);
    });

    // --- MÓVIL: el primer toque abre el submenú (no navega); el enlace queda accesible aparte ---
    if(topLink){
      topLink.addEventListener('click', function(e){
        if(window.innerWidth <= MOBILE){
          e.preventDefault();
          e.stopPropagation();
          var wasOpen = item.classList.contains('open');
          // cerrar los demás
          items.forEach(function(i){ if(i!==item) i.classList.remove('open'); });
          // alternar este
          item.classList.toggle('open', !wasOpen);
        }
      });
    }
  });

  // cerrar al tocar fuera (móvil)
  document.addEventListener('click', function(e){
    if(window.innerWidth <= MOBILE && !e.target.closest('.site-nav .nav-item.has-sub')){
      items.forEach(function(i){ i.classList.remove('open'); });
    }
  });
})();
